import { render, staticRenderFns } from "./Spot.vue?vue&type=template&id=ef12c632&scoped=true&"
import script from "./Spot.vue?vue&type=script&lang=ts&"
export * from "./Spot.vue?vue&type=script&lang=ts&"
import style0 from "./Spot.vue?vue&type=style&index=0&id=ef12c632&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef12c632",
  null
  
)

export default component.exports